import React from 'react';
import PropTypes from 'prop-types';

export default class ErrorBoundary extends React.Component {
	static propTypes = {
		children: PropTypes.oneOfType([
			PropTypes.node,
			PropTypes.arrayOf(PropTypes.node),
		]).isRequired,
		renderError: PropTypes.func.isRequired,
	};

	state = {
		hasError: false,
		error: null,
		errorInfo: null,
	};

	componentDidCatch(error, errorInfo) {
		this.setState({ hasError: true, error, errorInfo });
		//  notify our error to logger
	}

	render() {
		const { hasError } = this.state;
		if (hasError) {
			return this.props.renderError();
		}
		return this.props.children;
	}
}
